import { Fetch } from 'lib';
import type { NoticeDto } from 'types';

type RequestResponses = {
  notices: NoticeDto[];
};

const getPublicNotices = async () =>
  await Fetch<RequestResponses>({
    url: 'adminPageBuilder/getPublicNotices',
  });

export { getPublicNotices };
